import { Link } from 'react-router-dom'
import { getActiveWargameConfig } from '@gamecodex/wargame-config'

export function Footer() {
  const cfg = getActiveWargameConfig()
  return (
    <footer className="relative border-t border-white/10 px-4 py-8 text-center text-xs text-white/40">
      <p>
        {cfg.wargameName} &copy; {new Date().getFullYear()} GameCodex. {cfg.seo.tagline}
      </p>
      <div className="mt-3 flex justify-center gap-4 text-[10px] uppercase tracking-wide text-white/30 sm:absolute sm:bottom-3 sm:right-4 sm:mt-0 sm:justify-end">
        <Link to="/legal/ai" className="hover:text-white/60">
          AI Policy
        </Link>
        <Link to="/legal/terms" className="hover:text-white/60">
          Terms of Service
        </Link>
      </div>
    </footer>
  )
}
